import {
  dynamicInboundCallsService, tagLookupService, capSettingsService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { bidAdjustmentsComparisonTypes } from '@/data/filterData';
import { camelCaseFormat } from '@/core/filters/camelCaseFormat';
import { ngVueEventBus, EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED } from '@/angularBridgeCode/utilities/ngVueEventBus';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR, STATUS_ERROR, RESET_ACTION_STATUS } from '@/store/helpers';

import { cloneDeep } from 'lodash';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

const nonFlattenableRtbSettings = {
  'customIntegrations': true,
  'passThroughBid': true,
  'trustedFormSettings': true,
  'trustedFormIntegration': true,
  'jornayaSettings': true
};

const perSecondsDropdownConfigMapping = {
  '': '',
  '60': 'Per Minute',
  '3600': 'Per Hour',
  '86400': 'Per Day',
  'Per Minute': 60,
  'Per Hour': 3600,
  'Per Day': 86400
};

const payoutOnDropdownConfigMapping = {
  '': '',
  'callLength': 'Call Length',
  'connectedCall': 'Call Successfully Connected',
  'incomingCall': 'Inbound Call',
  // 'convertedCall': 'Converted Call',
  'Call Length': 'callLength',
  'Call Successfully Connected': 'connectedCall',
  'Inbound Call': 'incomingCall',
  //'Converted Call': 'convertedCall',
};

const actions = {

  async pullDynamicInboundCallsCampaignSettings({ rootState, commit }, { campaignId }) {
    if (!campaignId) {
      //TODORTB toaster
      return;
    }

    const payload = {
      campaignId: campaignId,
    };

    let error = false;
    const campaignSettings = await dynamicInboundCallsService.getDynamicInboundCallsCampaignSettings(rootState.currentAccountId, campaignId).then((response) => response.data)
      .catch((err) => {
        if (err.data.messageCode === 101) {
          payload.val = false;
          commit('setSetupVal', payload);
        }
        error = true;
        return;
      });

    if (!error) {
      payload.val = _SanitizePulledSettings(campaignSettings, false);

      commit('setCampaignSettings', { ...payload } );
    } else {
      // TODO: Check condition to show toaster
      // throw Error();
    }
  },

  async pullDynamicInboundCallsPublisherSettings({ rootState, commit }, { campaignId, affiliateId }) {
    if (!campaignId || !affiliateId) {
      //TODORTB toaster
      return;
    }

    const payload = {
    };
    let publisherSettings;
    try {
      const response = await dynamicInboundCallsService.getDynamicInboundCallsPublisherSettings(rootState.currentAccountId, campaignId, affiliateId);
      publisherSettings = response.data;
    } catch (e) {
      utilities.showToaster(STATUS_ERROR, 'Error Retrieving Publisher Settings');
    }
    
    payload.val = _SanitizePulledSettings(publisherSettings, true);

    commit('setPublisherSettings', { campaignId, affiliateId, ...payload } );
  },

  async pullRTBAllPubSettings({ rootState, commit }, { campaignId }) {
    if (!campaignId) {
      return;
    }

    let publisherSettings;
    try {
      const response = await dynamicInboundCallsService.getDynamicInboundCallsAllPublisherSettings(rootState.currentAccountId, campaignId);
      publisherSettings = response.data;
    } catch (e) {
      utilities.showToaster(STATUS_ERROR, 'Error Retrieving Publisher Settings');
    }

    for (const publisherSetting of publisherSettings['publishers-rtb']) {
      const publisherSettingsToSanitize = { 'publisher-rtb': publisherSetting };
      commit('setPublisherSettings', { campaignId, affiliateId: publisherSetting.publisherId, val: _SanitizePulledSettings(publisherSettingsToSanitize, true)});
    }
  },

  resetAffiliate({ commit }, { campaignId, affiliateId }) {
    if (!campaignId) {
      //TODORTB toaster
      return;
    }

    const payload = {
      campaignId: campaignId,
      affiliateId: affiliateId
    };
    
    payload.val = {
      campaignSettingsOverride: false,
      enabled: true
    };

    commit('setPublisherSettings', { campaignId, affiliateId, ...payload } );
  },

  async pushSetupDynamicInboundCallsCampaignSettings({ rootState, commit, state, dispatch }, campaignId) {
    const campaignSettings = state.campaigns[campaignId];

    let payload = _SanitizeCampaignSettingsToPush(campaignSettings);

    await dynamicInboundCallsService.pushSetupDynamicInboundCallsCampaignSettings(rootState.currentAccountId, campaignId, payload);
    payload = _SanitizePulledSettings({ 'rtb': payload });
    commit('setCampaignSettings', { campaignId, val: payload } );
    
    await dispatch('pullRTBAllPubSettings', { campaignId });
  },

  async pushDynamicInboundCallsCampaignSettings({ rootState, state, dispatch }, campaignId) {
    const campaignSettings = state.campaigns[campaignId];

    const payload = _SanitizeCampaignSettingsToPush(campaignSettings);

    await dynamicInboundCallsService.pushDynamicInboundCallsCampaignSettings(rootState.currentAccountId, campaignId, payload);

    await dispatch('pullDynamicInboundCallsCampaignSettings', { campaignId });
  },

  async pushDynamicInboundCallsPublisherSettings({ rootState, commit, getters, dispatch }, { campaignId, affiliateId, newAffiliate, callCaps }) {
    const tempAffiliateId = newAffiliate ? 'newAffiliate' : affiliateId;
    const publisherSettings = getters.publisherSettings(campaignId, tempAffiliateId);
    const campaignSettings = getters.campaignSettings(campaignId);

    const payload = _SanitizePublisherSettingsToPush(publisherSettings, campaignSettings, callCaps);
    const response = await dynamicInboundCallsService.pushDynamicInboundCallsPublisherSettings(rootState.currentAccountId, campaignId, affiliateId, payload);
    const pulledSettings = _SanitizePulledSettings(response.data, true);
    commit('setPublisherSettings', { campaignId, affiliateId, val: pulledSettings } );

    if (newAffiliate) {
      dispatch('resetAffiliate', { campaignId, affiliateId: 'newAffiliate' });
      dispatch('setCampaignSettingsOverride', { campaignId, affiliateId: 'newAffiliate', val: false });
    }

    ngVueEventBus.$emit(EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, { affiliateId });
  },

  async getRtbUrls({ rootState }, { campaignId, affiliateId }) {
    if (affiliateId) {
      return await dynamicInboundCallsService.getDynamicInbondCallsUrlForAdminsAndAffiliates(rootState.currentAccountId, campaignId, affiliateId).then(response => response.data['rtb'].urls);
    }
    //This is for pubs to get their urls without knowing their affiliate ids
    return await dynamicInboundCallsService.getDynamicInbondCallsUrlForAffiliates(rootState.currentAccountId, campaignId).then(response => response.data['rtb'].urls);
  },

  async getMacros({ rootState, commit }) {
    try {
      const response = await tagLookupService.getTagMacros(rootState.currentAccountId, 'rtb');
      commit('setMacros', response.data.macros);
    } catch (e) {
      commit('setMacros', {});
    }
  },
  
  async getBulkAdjustmentLists({ rootState, commit }) {
    try {
      const response = await dynamicInboundCallsService.getBulkModifiers(rootState.currentAccountId);
      commit('setBulkModifiers', response.data.rtbBulkModifierLists);
    } catch (e) {
      commit('setBulkModifiers', []);
    }
  },

  async uploadBulkModifiers({ rootState, dispatch, commit}, { file }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'uploadBulkModifiers' });
    try {
      const response = await dynamicInboundCallsService.uploadBulkModifiers(rootState.currentAccountId, file);
      await dispatch('getBulkAdjustmentLists');
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'uploadBulkModifiers', uploadedListId: response?.data?.rtbBulkModifierList?.id });
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'uploadBulkModifiers', error: error  });
    }
  },

  async customScoringRequest({ rootState, commit }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'customScoringRequest' });
    try {
      const response = await dynamicInboundCallsService.customScoringRequest(rootState.currentAccountId, payload);
      if (response.data.responseCode && response.data.responseCode >= 200 && response.data.responseCode < 300) {
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'customScoringRequest' });
      } else if (response.data.responseCode && response.data.responseCode >= 300 && response.data.responseCode <= 500) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: 'customScoringRequest', error: response.data.body });
      }
      return response.data;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'customScoringRequest', error: e.data.message  });
    }
  },

  resetCustomScoringRequestStatus({ commit }) {
    commit(RESET_ACTION_STATUS, { actionName: 'customScoringRequest' });
  },

  setSetupVal({ commit }, payload) {
    commit('setSetupVal', payload);
  },

  setCampaignSettingsOverride({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setCampaignSettingsOverride', payload);
    }
  },

  setCampaignSettingsOverrideWithoutNotification({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setCampaignSettingsOverrideWithoutNotification', payload);
    }
  },

  setEnabled({ commit }, payload) {
    commit('setEnabled', payload);
  },

  setPayoutCapacity({ commit }, payload) {
    commit('setPayoutCapacity', payload);
  },

  setSipOnly ({ commit }, payload) {
    commit('setSipOnly', payload);
  },

  setCallerIdRequired ({ commit }, payload) {
    commit('setCallerIdRequired', payload);
  },

  setIcp({ commit }, payload) {
    commit('setIcp', payload);
  },

  setJournayaTcpa({ commit }, payload) {
    commit('setJournayaTcpa', payload);
  },

  setTrustedForm({ commit }, payload) {
    commit('setTrustedForm', payload);
  },

  setTrustedFormIntegration({ commit }, payload) {
    commit('setTrustedFormIntegration', payload);
  },

  setTrustedFormSettings({ commit }, payload) {
    commit('setTrustedFormSettings', payload);
  },
  
  setJornayaSettings({ commit }, payload) {
    commit('setJornayaSettings', payload);
  },

  setBidExpirationInSeconds({ commit }, payload) {
    commit('setBidExpirationInSeconds', payload);
  },

  setRouteCallsForStaleBids({ commit }, payload) {
    commit('setRouteCallsForStaleBids', payload);
  },

  setRateLimitOverride({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setRateLimitOverride', payload);
    }
  },

  setMaxRequests({ commit }, payload) {
    commit('setMaxRequests', payload);
  },

  setPerSeconds({ commit }, payload) {
    commit('setPerSeconds', payload);
  },

  setBidSettingsOverride({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setBidSettingsOverride', payload);
    }
  },

  setBaseBidAmount({ commit }, payload) {
    commit('setBaseBidAmount', payload);
  },

  setmaxBidAmount({ commit }, payload) {
    commit('setmaxBidAmount', payload);
  },

  setminBidAmount({ commit }, payload) {
    commit('setminBidAmount', payload);
  },

  setConversionType({ commit }, payload) {
    commit('setConversionType', payload);
  },

  setStartTimerEvent({ commit }, payload) {
    commit('setStartTimerEvent', payload);
  },

  setCallLengthInSeconds({ commit }, payload) {
    commit('setCallLengthInSeconds', payload);
  },

  setSecondsFromLastCall({ commit }, payload) {
    commit('setSecondsFromLastCall', payload);
  },

  setPassThroughBid({ commit }, payload) {
    commit('setPassThroughBid', payload);
  },
  setPassThroughBidOverride({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setPassThroughBidOverride', payload);
    }
  },

  setCustomScoringSettings({ commit }, payload) {
    commit('setCustomScoringSettings', payload);
  },

  setCustomScoringModified({ commit }, payload) {
    commit('setCustomScoringModified', payload);
  },

  setBidAdjustmentsOverride({ commit }, payload) {
    if (payload.affiliateId) {
      commit('setBidAdjustmentsOverride', payload);
    }
  },

  setMinDurationAdjustments({ commit }, payload) {
    commit('setMinDurationAdjustments', payload);
  },

  setMinDurationAdjustmentsOverride({ commit }, payload) {
    commit('setMinDurationAdjustmentsOverride', payload);
  },

  saveBidAdjustments({ commit }, payload) {
    commit('saveBidAdjustments', payload);
  },

  setRows({ commit }, payload) {
    commit('setRows', payload);
  },

  setRowsPreviousState({ commit }, payload) {
    commit('setRowsPreviousState', payload);
  }
};

function _resetPayoutCapacity({ payoutCapacity, callCaps }) {
  const newPayoutCapacity = cloneDeep(payoutCapacity)
  Object.keys(callCaps).forEach((key) => {
    if (callCaps[key] === -1) {
      newPayoutCapacity[key] = -1
    }
  })
  return newPayoutCapacity;
}

function _SanitizePulledSettings(settings, isAffiliate) {
  const settingsObject = isAffiliate ? 'publisher-rtb' : 'rtb';
  const pulledSettings = settings[settingsObject];

  const rateLimitObject = isAffiliate ? 'rateLimitOverride' : 'rateLimit';
  const bidSettingsObject = isAffiliate ? 'bidSettingsOverride' : 'bidSettings';
  const passThroughBidObject = isAffiliate ? 'passThroughBidOverride' : 'passThroughBid';
  const minDurationAdjustmentsObject = isAffiliate ? 'minDurationAdjustmentsOverride' : 'minDurationAdjustments';
  const bidAdjustmentsObject = isAffiliate ? 'bidAdjustmentsOverride' : 'bidAdjustments';

  const result = _flattenObj(pulledSettings);
  result.setupVal = true;

  _addIntegrationSettings(pulledSettings, result);

  if (result.perSeconds) {
    result.perSeconds = perSecondsDropdownConfigMapping[result.perSeconds];
  }

  if (result.conversionType) {
    result.conversionType = payoutOnDropdownConfigMapping[result.conversionType];
  }

  if (pulledSettings[bidAdjustmentsObject]) {
    result.bidAdjustments = _SanitizePulledBidAdjustments(pulledSettings[bidAdjustmentsObject]);
    result.rows = cloneDeep(result.bidAdjustments);
    result.rowsPreviousState = cloneDeep(result.bidAdjustments);
  }

  if (pulledSettings['trustedFormIntegration']) {
    result.trustedFormIntegration = pulledSettings['trustedFormIntegration'];
  }

  if (pulledSettings['trustedFormSettings']) {
    result.trustedFormSettings = pulledSettings['trustedFormSettings'];
  }

  if (pulledSettings['customIntegrations'] && pulledSettings['customIntegrations']['customScoring']) {
    result.customScoring = pulledSettings['customIntegrations']['customScoring'];
  }

  if (pulledSettings['jornayaSettings']) {
    result.jornayaSettings = pulledSettings['jornayaSettings'];
  }
  
  if (pulledSettings['capps']) {
    const initializedCap = capSettingsService.initializeCallCapSettings(
      capSettingsService.capSettingType.BOTH,
      cloneDeep(pulledSettings['capps']),
      {
        key: 'concurrencyCap',
        capSettingType: capSettingsService.defaultCapSettingsType,
      });
    result.capps = initializedCap
  }

  if (isAffiliate) {
    result.rtbId = _GetValueOrDefault(pulledSettings.id, '');

    result.callerIdRequiredOverride = pulledSettings.callerIdRequiredOverride;

    result.rateLimitOverride = pulledSettings[rateLimitObject] ? true : null;
    result.bidSettingsOverride = pulledSettings[bidSettingsObject] ? true : null;
    result.passThroughBidOverride = pulledSettings[passThroughBidObject] ? true : null;
    result.bidAdjustmentsOverride = pulledSettings[bidAdjustmentsObject] ? true : null;
    result.minDurationAdjustmentsOverride = pulledSettings[minDurationAdjustmentsObject] || null;

    //TODORTB change the callerIdRequiredOverride part if we decide to create a new section(for siponly and callerIdRequired) in the RTB settings
    result.campaignSettingsOverride = !result.enabled || (result.callerIdRequiredOverride != null) || (result.rateLimitOverride != null) || (result.bidSettingsOverride != null) || (result.passThroughBidOverride != null) || (result.bidAdjustmentsOverride != null);
  } else {
    result.minDurationAdjustments = pulledSettings[minDurationAdjustmentsObject];
    result.callerIdRequired = _GetValueOrDefault(pulledSettings.callerIdRequired, false);
    result.passThroughBid = pulledSettings[passThroughBidObject];
  }

  if (pulledSettings.tags) {
    result.tags = pulledSettings.tags;
  }
  
  return result;
}

function _flattenObj(obj, parent, res = {}) {
  for (const key in obj) {
    if (key != null && nonFlattenableRtbSettings[key]) continue;

    if(typeof obj[key] == 'object'){ 
      _flattenObj(obj[key], key, res);
    } else {
      if (typeof obj[key] == 'number' && key != 'secondsFromLastCall') {
        obj[key] = obj[key].toString();
      }
      res[key] = obj[key];
    }
  }
  return res;
}

function _addIntegrationSettings(rawInput, result)
{
  if (rawInput && rawInput.customIntegrations && result) {
    // legacy - incorrect spelling of Jornaya TCPA setup key
    if (rawInput.customIntegrations.journayaTCPA) {
      result.journayaTcpa = rawInput.customIntegrations.journayaTCPA.state;
      result.journayaTcpaParseSettings = rawInput.customIntegrations.journayaTCPA.parseSettings;
    }

    // correct spelling of Jornaya TCPA setup key
    if (rawInput.customIntegrations.jornayaTCPA) {
      result.journayaTcpa = rawInput.customIntegrations.jornayaTCPA.state;
      result.journayaTcpaParseSettings = rawInput.customIntegrations.jornayaTCPA.parseSettings;
    }

    if (rawInput.customIntegrations.trustedForm) {
      result.trustedForm = rawInput.customIntegrations.trustedForm.state;
    }

    //all "other" integrations that should be preserved
    var otherIntegrationKeys = Object.keys(rawInput.customIntegrations).filter((key) => {
      return key != 'journayaTCPA' && key != 'jornayaTCPA' && key != 'trustedForm' && key != 'customScoring';
    });

    if (otherIntegrationKeys && otherIntegrationKeys.length > 0) {
      result.otherIntegrations = new Map();

      otherIntegrationKeys.forEach(key => {
        result.otherIntegrations[key] = rawInput.customIntegrations[key];
      });
    }

    // Check if custom scoring v1 exists and return boolean
    result.hasCustomScoringV1 = _checkCustomScoringV1(rawInput.customIntegrations);
  }
}

function _SanitizeCampaignSettingsToPush(campaignSettings) {
  const result = {
    enabled: _GetValueOrDefault(campaignSettings.enabled, false),
    sipOnly: _GetValueOrDefault(campaignSettings.sipOnly, false),
    callerIdRequired: _GetValueOrDefault(campaignSettings.callerIdRequired, false),
    icp: _GetValueOrDefault(campaignSettings.icp, 'Off'),
    customIntegrations: {
      jornayaTCPA: {
        state: _GetValueOrDefault(campaignSettings.journayaTcpa, 'Off'),
        parseSettings: _GetValueOrDefault(campaignSettings.journayaTcpaParseSettings, null)
      },
      trustedForm: {
        state: _GetValueOrDefault(campaignSettings.trustedForm, 'Off')
      },
      customScoring: _GetValueOrDefault(campaignSettings.customScoring, null)
    },
    bidExpirationPolicy: {
      bidExpirationInSeconds: _GetValueOrDefault(parseInt(campaignSettings.bidExpirationInSeconds), 20),
      routeCallsForStaleBids: _GetValueOrDefault(campaignSettings.routeCallsForStaleBids, false),
    },
    rateLimit: {
      maxRequests: _GetValueOrDefault(parseInt(campaignSettings.maxRequests), 10),
      perSeconds: perSecondsDropdownConfigMapping[_GetValueOrDefault(campaignSettings.perSeconds, 'Per Minute')]
    },
    bidSettings: {
      baseBidAmount: _GetValueOrDefault(parseFloat(campaignSettings.baseBidAmount), 10),
      maxBidAmount: _GetValueOrDefault(parseFloat(campaignSettings.maxBidAmount), 25),
      minBidAmount: _GetValueOrDefault(parseFloat(campaignSettings.minBidAmount), null),
      conversionType: payoutOnDropdownConfigMapping[_GetValueOrDefault(campaignSettings.conversionType, 'Inbound Call')],
      conversionArgs: {
        callLengthInSeconds: _GetValueOrDefault(parseInt(campaignSettings.callLengthInSeconds), 30),
        startTimerEvent: _GetValueOrDefault(campaignSettings.startTimerEvent, 'OnIncomingCall'),
      },
      deDupeSetting: {
        secondsFromLastCall: _GetValueOrDefault(campaignSettings.secondsFromLastCall, 0)
      }
    },
    passThroughBid: {
      enabled: _GetValueOrDefault(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.enabled : false),
      maxBid: _GetValueOrDefault(parseFloat(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.maxBid : 25)),
      bidMarginPercentage: _GetValueOrDefault(parseFloat(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.bidMarginPercentage : null)),
      bidMarginAmount: _GetValueOrDefault(parseFloat(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.bidMarginAmount : null)),
      minBidMarginPercentageAfterAdjustments: _GetValueOrDefault(parseFloat(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.minBidMarginPercentageAfterAdjustments : null)),
      minBidMarginAmountAfterAdjustments: _GetValueOrDefault(parseFloat(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.minBidMarginAmountAfterAdjustments : null)),
      allowBidsAtLoss: _GetValueOrDefault(campaignSettings.passThroughBid ? campaignSettings.passThroughBid.allowBidsAtLoss : false),
    },
    trustedFormIntegration: {
      integrationMethod: _GetValueOrDefault(campaignSettings.trustedFormIntegration?.integrationMethod, 'Claim')
    },
    trustedFormSettings: {
      apiKey: _GetValueOrDefault(campaignSettings.trustedFormSettings ? campaignSettings.trustedFormSettings.apiKey : null),
      certificateTagName: _GetValueOrDefault(campaignSettings.trustedFormSettings ? campaignSettings.trustedFormSettings.certificateTagName : null),
    },
    jornayaSettings: {
      accountCode: _GetValueOrDefault(campaignSettings.jornayaSettings ? campaignSettings.jornayaSettings.accountCode : null),
      agencyCode: _GetValueOrDefault(campaignSettings.jornayaSettings ? campaignSettings.jornayaSettings.agencyCode : null),
      auditKey: _GetValueOrDefault(campaignSettings.jornayaSettings ? campaignSettings.jornayaSettings.auditKey : null)
    }
  };

  if (Object.keys(result.trustedFormSettings).length === 0 || (!result.trustedFormSettings?.apiKey || !result.trustedFormSettings?.certificateTagName)) {
    result.trustedFormSettings = null;
  }

  if (Object.keys(result.jornayaSettings).length === 0 || (!result.jornayaSettings?.accountCode || !result.jornayaSettings?.agencyCode || !result.jornayaSettings?.auditKey)) {
    result.jornayaSettings = null;
  }

  if (campaignSettings.journayaTcpaModified || campaignSettings.trustedFormModified || campaignSettings.customScoringModified) {    
    const otherIntegrations = campaignSettings.otherIntegrations;
    if (otherIntegrations) {
      Object.keys(otherIntegrations).forEach(key => {
        result.customIntegrations[key] = otherIntegrations[key];
      });
    }
  } else {
    delete result.customIntegrations;
  }

  if (campaignSettings.bidAdjustments) {
    result.bidAdjustments = campaignSettings.bidAdjustments.map(ba => _SanitizeBidAdjustmentToPush(ba));
  }

  result.minDurationAdjustments = campaignSettings.minDurationAdjustments;

  return result;
}

function _checkCustomScoringV1(customIntegrations) {
  let hasCustomScoringV1 = false;
  // Iterate through custom integrations and return true if condition met
  for (const key in customIntegrations) {
    if (
      customIntegrations.hasOwnProperty(key) &&
      customIntegrations[key]?.customIntegrationType === 'score' &&
      customIntegrations[key]?.scoringSettingV2Migrated === false
    ) {
      hasCustomScoringV1 = true;
      break;
    }
  }
  return hasCustomScoringV1;
}

function _SanitizePublisherSettingsToPush(affiliateSettings, campaignSettings, callCaps = {}) {
  if (!affiliateSettings.campaignSettingsOverride) {
    return {
      enabled: true,
      callerIdRequiredOverride: null,
      rateLimitOverride: null,
      bidSettingsOverride: null,
      passThroughBidOverride: null,
      minDurationAdjustmentsOverride: null,
      bidAdjustmentsOverride: null,
      capps: null,
    };
  }

  const result = {
    enabled: _GetValueOrDefault(affiliateSettings.enabled, campaignSettings ? campaignSettings.enabled : false),
    // This would set the default value to null, so publisher settings would use the campaign settings when not set to anything
    callerIdRequiredOverride: _GetValueOrDefault(affiliateSettings.callerIdRequiredOverride, campaignSettings ? campaignSettings.callerIdRequired : null),
  };
  if (affiliateSettings.enabled) {
    result.capps = _resetPayoutCapacity({
      payoutCapacity: _GetValueOrDefault(affiliateSettings.capps, null),
      callCaps
    });
  }

  if (affiliateSettings.rateLimitOverride) {
    result.rateLimitOverride = {
      maxRequests: _GetValueOrDefault(parseInt(affiliateSettings.maxRequests), campaignSettings ? parseInt(campaignSettings.maxRequests) : 10),
      perSeconds: perSecondsDropdownConfigMapping[_GetValueOrDefault(affiliateSettings.perSeconds, campaignSettings ? campaignSettings.perSeconds : 'Per Minute')]
    };
  } else {
    result.rateLimitOverride = null;
  }

  if (affiliateSettings.bidSettingsOverride) {
    result.bidSettingsOverride = {
      baseBidAmount: _GetValueOrDefault(parseFloat(affiliateSettings.baseBidAmount), campaignSettings ? parseFloat(campaignSettings.baseBidAmount) : 10),
      maxBidAmount: _GetValueOrDefault(parseFloat(affiliateSettings.maxBidAmount), campaignSettings ? parseFloat(campaignSettings.maxBidAmount) : 25),
      minBidAmount: _GetValueOrDefault(parseFloat(affiliateSettings.minBidAmount), campaignSettings ? parseFloat(campaignSettings.minBidAmount) : null),
      conversionType: payoutOnDropdownConfigMapping[_GetValueOrDefault(affiliateSettings.conversionType, campaignSettings ? campaignSettings.conversionType : 'Incoming Call')],
      conversionArgs: {
        callLengthInSeconds: _GetValueOrDefault(parseInt(affiliateSettings.callLengthInSeconds), campaignSettings ? parseInt(campaignSettings.callLengthInSeconds) : 30),
        startTimerEvent: _GetValueOrDefault(affiliateSettings.startTimerEvent, campaignSettings ? campaignSettings.startTimerEvent : 'OnIncomingCall')
      },
      deDupeSetting: {
        secondsFromLastCall: _GetValueOrDefault(affiliateSettings.secondsFromLastCall, campaignSettings ? campaignSettings.secondsFromLastCall : 0)
      }
    };
  } else {
    result.bidSettingsOverride = null;
  }

  if (affiliateSettings.passThroughBidOverride) {
    result.passThroughBidOverride = {
      maxBid: _GetValueOrDefault(parseFloat(affiliateSettings.maxBid)),
      bidMarginPercentage: _GetValueOrDefault(parseFloat(affiliateSettings.bidMarginPercentage)),
      bidMarginAmount: _GetValueOrDefault(parseFloat(affiliateSettings.bidMarginAmount)),
      minBidMarginPercentageAfterAdjustments: _GetValueOrDefault(parseFloat(affiliateSettings.minBidMarginPercentageAfterAdjustments)),
      minBidMarginAmountAfterAdjustments: _GetValueOrDefault(parseFloat(affiliateSettings.minBidMarginAmountAfterAdjustments)),
      allowBidsAtLoss: _GetValueOrDefault(affiliateSettings.allowBidsAtLoss, false),
    };
    result.minDurationAdjustmentsOverride = affiliateSettings.minDurationAdjustments;
  } else {
    result.passThroughBidOverride = null;
    // Set minDurationAdjustmentsOverride to null if passThroughBidOverride is not enabled
    result.minDurationAdjustmentsOverride = null;
  }

  if (affiliateSettings.bidAdjustmentsOverride) {
    result.bidAdjustmentsOverride = _GetValueOrDefault(affiliateSettings.bidAdjustments, []).map(ba => _SanitizeBidAdjustmentToPush(ba));
  } else {
    result.bidAdjustmentsOverride = null;
  }

  return result;
}

function _GetValueOrDefault(value, defaultValue) {
  // Earlier it'd only check if it's truthy, return the passed `value` else return the `defaultValue`
  // Changed this so we would check if value is not `undefined` or `null`. Didn't use a strict equality check so it would check for both `undefined` and `null`
  // If 
  return value != null
    && _checkIsNumberAndValid(value) // check if value is NaN
    ? value : defaultValue;
}

function _checkIsNumberAndValid(value) {
  return typeof value !== 'number' || !isNaN(value);
}

function _SanitizePulledBidAdjustments(bidAdjustments) {
  const result = [];

  for (let index = 0; index < bidAdjustments.length; index++) {
    const ba = _SanitizePulledBidAdjustment(bidAdjustments[index]);

    //id is needed because the draggabletable uses it as a key
    result.push({ id: Date.now() + index, priority: index, ...ba });
  }

  return result;
}

function _SanitizePulledBidAdjustment(bidAdjustment) {
  const tag = bidAdjustment.criteria.tagId;
  //TODORTB talk to Dima about 'forMultipleValues' field, it is not implemented in the API yet
  let comparer = _GetComparisonPropertiesToPull(bidAdjustment.criteria.comparisonType, bidAdjustment.criteria.isNegativeMatch /*, bidadjustments.criteria.forMultipleValues*/);
  let compValue = bidAdjustment.criteria.value;
  const operation = bidAdjustment.adjustmentType;
  const opValue = bidAdjustment.adjustmentValue;
  const bulkListId = bidAdjustment.bulkListId;
  const overrideTag = bidAdjustment.overrideTag;

  if (comparer == 'Wildcard Does Not Match' && compValue == '?*') {
    comparer = 'Has No Value';
    compValue = '';
  }

  return {
    tag,
    comparer,
    compValue,
    operation,
    opValue,
    bulkListId,
    overrideTag
  };
}

function _SanitizeBidAdjustmentToPush(bidAdjustment) {
  const comparisonProperties = _GetComparisonPropertiesToPush(bidAdjustment.comparer);
  let adjustmentType = bidAdjustment.operation;
  let adjustmentValue = bidAdjustment.opValue != null ? parseFloat(bidAdjustment.opValue.toString().replace(/[^0-9.-]/g, '')) : 0;

  if (comparisonProperties.comparisonType === 'REQUIRED') {
    return {
      criteria: {
        tagId: bidAdjustment.tag,
        comparisonType: comparisonProperties.comparisonType,
        value: bidAdjustment.compValue,
        isNegativeMatch: comparisonProperties.isNegativeMatch
      },
      bulkListId: bidAdjustment.bulkListId,
    };
  }

  if (bidAdjustment.operation === 'Subtract') {
    adjustmentType = 'Add';
    adjustmentValue = -1 * Math.abs(adjustmentValue);
  } else if (bidAdjustment.operation === 'Reject') {
    adjustmentValue = 0;
  } else if (bidAdjustment.operation === 'Override From Tag' || bidAdjustment.operation === 'OverrideFromTag') {
    adjustmentType = 'OverrideFromTag';
    adjustmentValue = 0;
  }

  if (bidAdjustment.comparer === 'Has No Value') {
    bidAdjustment.compValue = '';
  }

  if (comparisonProperties.comparisonType !== 'BULK') {
    bidAdjustment.bulkListId = null;
  }

  if (bidAdjustment.operation !== 'Override From Tag' && bidAdjustment.operation !== 'OverrideFromTag') {
    bidAdjustment.overrideTag = null;
  }

  return {
    criteria: {
      tagId: bidAdjustment.tag,
      comparisonType: comparisonProperties.comparisonType,
      value: bidAdjustment.compValue,
      isNegativeMatch: comparisonProperties.isNegativeMatch,
    },
    adjustmentType,
    adjustmentValue,
    bulkListId: bidAdjustment.bulkListId,
    overrideTag: bidAdjustment.overrideTag
  };
}

//TODORTB talk to Dima about 'forMultipleValues' field, it is not implemented in the API yet
function _GetComparisonPropertiesToPull(comparisonType, isNegativeMatch/*, forMultipleValues*/) {
  var comparerObject = bidAdjustmentsComparisonTypes.find(bact => bact.key === comparisonType && bact.isNegativeMatch === isNegativeMatch/* && bact.forMultipleValues === forMultipleValues*/);
  return camelCaseFormat(comparerObject?.value);
}

function _GetComparisonPropertiesToPush(comparer) {
  const comparisonTypeValue = comparer.toUpperCase().replace(/ /g, '_');//replaces spaces for '_'
  const bidAdjustmentsComparisonType = bidAdjustmentsComparisonTypes.find(bact => bact.value === comparisonTypeValue);

  const comparisonType = bidAdjustmentsComparisonType ? bidAdjustmentsComparisonType.key : 'EQUALS';

  const isNegativeMatch = bidAdjustmentsComparisonType ? bidAdjustmentsComparisonType.isNegativeMatch : false;

  //TODORTB talk to Dima about this field, it is not implemented in the API yet
  //let forMultipleValues = bidAdjustmentsComparisonType ? bidAdjustmentsComparisonType.forMultipleValues : false;

  return {
    comparisonType,
    isNegativeMatch,
    //TODORTB talk to Dima about this field, it is not implemented in the API yet
    //forMultipleValues
  };
}

export default actions;